import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InchidereLucrare, StoreDocResponse, DocumentData, SearchDocsIesire, DocumentDataIesire, AwbDocumentDetail } from './document.interface';
import { SearchedDocument, SearchDocumentsPayload, SearchedAllDocuments } from '../borderou/borderou.interface';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    private token!: string;
    private httpOptions: any;

    private sablonContent = new Subject<{ content: string, section: string }>();
    sablonContent$ = this.sablonContent.asObservable();

    private basePath = environment.interop.basePath;
    private getDocumentsListDTURL =
        this.basePath + environment.interop.indoc.documents.getDocumentsListDT;

    private store =
        this.basePath + environment.interop.indoc.documents.storeDocument;
    private storeIntern =
        this.basePath + environment.interop.indoc.documents.storeIntern;
    private storeIesire =
        this.basePath + environment.interop.indoc.documents.storeIesire;

    private findDocumentURL =
        this.basePath + environment.interop.indoc.documents.find;
    private findDocsIesireURL =
        this.basePath + environment.interop.indoc.documents.findDocsIesire;
    private mesagerieHistoryURL =
        this.basePath + environment.interop.indoc.documents.mesagerieHistory;
    private docActivityURL =
        this.basePath + environment.interop.indoc.documents.getActivity;
    private docChildrenURL =
        this.basePath + environment.interop.indoc.documents.getChildren;

    private exportHistoryUrl =
        this.basePath + environment.interop.indoc.documents.exportHistory;
    private updateStatusURL =
        this.basePath + environment.interop.indoc.documents.updateStatus;
    private updatePriorityURL =
        this.basePath + environment.interop.indoc.documents.updatePriority;
    private postMessageURL =
        this.basePath + environment.interop.indoc.documents.postMessage;
    private fileUploadUrl =
        this.basePath + environment.interop.indoc.documents.uploadFile;
    public tempFileDownloadUrl =
        this.basePath + environment.interop.indoc.documents.tempFileDownload;
    public documentDownloadFileUrl =
        this.basePath + environment.interop.indoc.documents.documentDownloadFile;
    private documentUploadFileUrl =
        this.basePath + environment.interop.indoc.documents.documentUploadFile;
    private documentDeleteFileUrl =
        this.basePath + environment.interop.indoc.documents.documentDeleteFile;

    private updateInfoURL =
        this.basePath + environment.interop.indoc.documents.updateInfo;
    private updateEntityURL =
        this.basePath + environment.interop.indoc.documents.updateEntity;
    private updateEmitentExternURL =
        this.basePath + environment.interop.indoc.documents.updateEmitentExtern;
    private updateObservatiiURL =
        this.basePath + environment.interop.indoc.documents.updateObservatii;
    private newDestinationURL =
        this.basePath + environment.interop.indoc.documents.activityDestination;

    private finalizareDocumentUrl =
        this.basePath + environment.interop.indoc.documents.finalizare;
    private rollBackInchidereDocumentUrl =
        this.basePath + environment.interop.indoc.documents.rollBackInchidere;

    private searchDocumentsUrl =
        this.basePath + environment.interop.indoc.documents.search;
    private searchAllDocumentsUrl =
        this.basePath + environment.interop.indoc.documents.searchAll;

    // activity sections
    private preluareActivityUrl =
        this.basePath + environment.interop.indoc.documents.preluareActivity;
    private rollBackPreluareActivityUrl =
        this.basePath + environment.interop.indoc.documents.rollBackPreluareActivity;
    private finalizareActivityUrl =
        this.basePath + environment.interop.indoc.documents.finalizareActivity;
    private rollBackFinalizareActivityUrl =
        this.basePath + environment.interop.indoc.documents.rollBackFinalizareActivity;
    private invalidareActivityUrl =
        this.basePath + environment.interop.indoc.documents.invalidareActivity;
    private activityDestinationUrl =
        this.basePath + environment.interop.indoc.documents.activityDestination;
    private registerNumberActivityServiciuUrl =
        this.basePath + environment.interop.indoc.documents.registerNumberActivityServiciu
    private removeActivityUrl =
        this.basePath + environment.interop.indoc.documents.removeActivity


    // generabile documents
    public downloadTableSignaturesURL =
        this.basePath + environment.interop.indoc.documents.generabile.downloadTableSignatures;


    private generateDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.generateDocument;

    private generateDocumentWithFileUrl =
        this.basePath + environment.interop.indoc.documents.generabile.uploadOnlineDocument;

    private validateDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.validateDocument;

    private resetDocumentValidatedUrl =
        this.basePath + environment.interop.indoc.documents.generabile.resetDocumentValidated;

    private resetDocumentIntocmitorValidatedUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.resetDocumentIntocmitorValidated;

    private uploadFinalDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.uploadedFinalDocument;

    private addToRegistruUrl =
        this.basePath + environment.interop.indoc.documents.generabile.addToRegistru;

    // Finalizare documente generate - flux SRP
    private finalizeDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.finalize;
    private sendToSRPUrl =
        this.basePath + environment.interop.indoc.documents.generabile.sendToSRP;
    private finalizeSRPUrl =
        this.basePath + environment.interop.indoc.documents.generabile.finalizeSRP;
    // Reset operațiuni finalizare
    private resetFinalizeUrl =
        this.basePath + environment.interop.indoc.documents.generabile.resetFinalize;
    private resetSendToSRPUrl =
        this.basePath + environment.interop.indoc.documents.generabile.resetSendToSRP;
    private resetFinalizeSRPUrl =
        this.basePath + environment.interop.indoc.documents.generabile.resetFinalizeSRP;

    public downloadDocumentOfficialUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.downloadDocumentOfficial;

    private istoricDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.istoricDocument;

    private destroyDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.destroyDocument;

    private updateDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.updateDocument;

    private updateValabilityDocGenerabilUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.editValabilitateDocGenerabil;

    private validateDocumentSuperiorUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.validateDocumentSuperior;

    public downloadDocumentSignedUrl =
        this.basePath + environment.interop.indoc.documents.generabile.downloadDocumentSigned;

    public downloadDocumentGeneratUrl =
        this.basePath + environment.interop.indoc.documents.generabile.downloadDocumentGenerat;

    public downloadDocumentSignatureSignedUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.downloadDocumentSignatureSigned;

    public downloadDocumentAnexaUrl =
        this.basePath + environment.interop.indoc.documents.generabile.downloadDocumentAnexa;

    private uploadDocumentGeneratAnexeUrl =
        this.basePath + 'api/registratura/document/generabile/upload-document-generat-anexe/';

    private deleteDocumentGeneratAnexaUrl =
        this.basePath + 'api/registratura/document/generabile/delete-document-generat-anexa/';

    private anulareSuperiorDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.cancelDocumentSuperior;

    // private generareDraftURL =
    //     this.basePath + environment.interop.indoc.documents.generabile.generareDraft;

    private sendDocumentToIntocmitorUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.sendDocumentToIntocmitor;
    private sendDocumentForwardIntocmitorUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.sendDocumentForwardIntocmitor;
    private sendDocumentForwardToSignerUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.sendDocumentForwardToSigner;

    private rsyncSignaturesDocumentGeneratUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.rsyncSignaturesDocumentGenerat;

    private setCetateanExemplarUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.setCetateanExemplar;

    private sendNotificationCetateanDocumentOficialUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.sendNotificationCetateanDocumentOficial;

    private resetDocumentOficialNotificareCetateanUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.resetDocumentOficialNotificareCetatean;

    private resetUploadDocumentOfficialUrl =
        this.basePath +
        environment.interop.indoc.documents.generabile.resetUploadDocumentOfficial;

    private setDocTypeForDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.setDocTypeForDocument;

    private updateCurrentSignatureDocumentUrl =
        this.basePath + environment.interop.indoc.documents.generabile.updateCurrentSignatureDocument;

    private storeAWBUrl =
        this.basePath + environment.interop.indoc.documents.storeAWB;
    private findAWBUrl =
        this.basePath + environment.interop.indoc.documents.findAWB;
    private updateAWBUrl =
        this.basePath + environment.interop.indoc.documents.updateAWB;
    private duplicateAWBUrl =
        this.basePath + environment.interop.indoc.documents.duplicateAWB;

    constructor(private http: HttpClient) { }

    getRequestsDT() {
        return this.http.get(this.getDocumentsListDTURL, this.httpOptions);
    }

    getManual() {
        return this.http.get(
            this.basePath + 'api/registratura/documentatie/download',
            { responseType: 'blob' }
        );
    }

    storeDocumentIntrare(data: any) {
        return this.http.post<{ errors: boolean; data: StoreDocResponse; status_code: number }>(this.store, data);
    }

    storeDocumentIntern(data: any) {
        return this.http.post<{ errors: boolean; data: StoreDocResponse; status_code: number }>(this.storeIntern, data);
    }

    storeDocumentIesire(data: any) {
        return this.http.post<{ errors: boolean; data: StoreDocResponse; status_code: number }>(this.storeIesire, data);
    }

    findDocument(id: number) {
        return this.http.get(this.findDocumentURL + id, this.httpOptions);
    }

    findDocsIesire(payload: SearchDocsIesire) {
        return this.http.post<{ errors: boolean; data: DocumentDataIesire[]; status_code: number }>(this.findDocsIesireURL, payload);
    }

    mesagerieHistory(id: number) {
        return this.http.get(this.mesagerieHistoryURL + id, this.httpOptions);
    }

    exportHistory(document_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + document_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    getActivityDoc(id: number) {
        return this.http.get(this.docActivityURL + id, this.httpOptions);
    }

    updateStatus(id: number, data: { current_status: number; message: string }) {
        return this.http.post(this.updateStatusURL + id, data, this.httpOptions);
    }

    updatePriority(id: number, data: { id_priority: number; message: string }) {
        return this.http.post(this.updatePriorityURL + id, data, this.httpOptions);
    }

    postMessage(id: number, data: { type: number; newMessage: string }) {
        return this.http.post(this.postMessageURL + id, data, this.httpOptions);
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    documentUploadFile(id: number, data: any) {
        return this.http.post(this.documentUploadFileUrl + id, data, this.httpOptions);
    }

    documentDeleteFile(id_document: number, id_file: number) {
        return this.http.delete(this.documentDeleteFileUrl + `${id_document}/${id_file}`, this.httpOptions);
    }

    updateInfo(id: number, data: any) {
        return this.http.post(this.updateInfoURL + id, data, this.httpOptions);
    }

    updateEntity(id: number, data: any) {
        return this.http.post(this.updateEntityURL + id, data, this.httpOptions);
    }

    updateEmitentExtern(id: number, data: any) {
        return this.http.post(this.updateEmitentExternURL + id, data, this.httpOptions);
    }

    updateObservatii(id: number, data: any) {
        return this.http.post(this.updateObservatiiURL + id, data, this.httpOptions);
    }

    addActivityDestination(id: number, data: {}) {
        return this.http.post(this.newDestinationURL + id, data, this.httpOptions);
    }

    finalizareDocument(docId: number, data: InchidereLucrare) {
        return this.http.post(
            this.finalizareDocumentUrl + docId,
            data,
            this.httpOptions
        );
    }

    resetInchidereDocument(docId: number, data: any) {
        return this.http.post(this.rollBackInchidereDocumentUrl + docId, data);
    }

    searchDocuments(payload: SearchDocumentsPayload) {
        return this.http
            .post<{ errors: boolean; data: SearchedDocument[]; status_code: number }>(
                this.searchDocumentsUrl, payload
            )
            .pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in searching documents:', error);
                    return throwError(error);
                })
            );
    }

    searchAllDocuments(payload: SearchDocumentsPayload) {
        return this.http
            .post<{ errors: boolean; data: SearchedAllDocuments; status_code: number }>(
                this.searchAllDocumentsUrl, payload
            )
            .pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in searching all documents:', error);
                    return throwError(error);
                })
            );
    }

    sendSablonContent(content: string, section: string) {
        this.sablonContent.next({ content, section });
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    // operations section
    preluareActivity(activityId: number) {
        return this.http.get(this.preluareActivityUrl + activityId, this.httpOptions);
    }

    rollBackPreluareActivity(activityId: number, data: any) {
        return this.http.post(this.rollBackPreluareActivityUrl + activityId, data);
    }

    finalizareActivity(activityId: number, data: any) {
        return this.http.post(this.finalizareActivityUrl + activityId, data);
    }

    rollBackFinalizareActivity(activityId: number, data: any) {
        return this.http.post(this.rollBackFinalizareActivityUrl + activityId, data);
    }

    registerNumberActivityServiciu(activityId: number, data: any) {
        return this.http.post(this.registerNumberActivityServiciuUrl + activityId, data);
    }

    removeActivity(activityId: number, data: any) {
        return this.http.post(this.removeActivityUrl + activityId, data);
    }

    getChildrenDoc(id: number) {
        return this.http.get(this.docChildrenURL + id, this.httpOptions);
    }





    // ==================== Document Assignment Management ==================== //

    /**
     * Get enriched assignment details for a document
     */
    getDocumentAssignmentDetails(documentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-generat/${documentId}/assignment-details`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document assignment details:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Manually assign operator to document
     */
    assignOperatorToDocument(documentId: number, assignmentData: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document-generat/${documentId}/assign-operator`;
        return this.http.post<any>(url, assignmentData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error assigning operator to document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update existing document assignment
     */
    updateDocumentAssignment(documentId: number, assignmentData: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document-generat/${documentId}/update-assignment`;
        return this.http.put<any>(url, assignmentData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating document assignment:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Remove assignment from document
     */
    unassignDocumentOperator(documentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-generat/${documentId}/unassign-operator`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error unassigning document operator:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available operators from cerere assignments for document assignment
     */
    getAvailableOperatorsForDocument(documentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-generat/${documentId}/available-operators`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            map((response: any) => response.data || []),
            catchError((error) => {
                console.error('Error getting available operators for document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Auto-assign all unassigned documents for a cerere
     */
    autoAssignAllDocumentsForCerere(documentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${documentId}/auto-assign-documents`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error auto-assigning documents for document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get document assignments summary for a cerere
     */
    getDocumentAssignmentsSummaryForCerere(documentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${documentId}/document-assignments-summary`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document assignments summary:', error);
                return throwError(error);
            })
        );
    }


    // ==================== Cerere Function Assignments ==================== //

    /**
     * Get assignments for a specific cerere
     */
    getCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Initialize assignments from cerere type template
     */
    initializeCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments/initialize`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error initializing document assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update assignments for a specific cerere
     */
    updateCerereAssignments(cerereId: number, assignmentsData: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments`;
        return this.http.put<any>(url, assignmentsData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating document assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Assign user to a specific function assignment
     */
    assignUserToCerereFunction(cerereId: number, assignmentId: number, userData: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments/${assignmentId}/assign-user`;
        return this.http.put<any>(url, userData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error assigning user to document function:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Unassign user from a specific function assignment
     */
    unassignUserFromCerereFunction(cerereId: number, assignmentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments/${assignmentId}/unassign-user`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error unassigning user from document function:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Mark assignment as completed
     */
    markCerereAssignmentCompleted(cerereId: number, assignmentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments/${assignmentId}/mark-completed`;
        return this.http.put<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error marking document assignment as completed:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Clear all assignments for a cerere
     */
    clearAllCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/${cerereId}/functie-assignments/clear-all`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error clearing all document assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available functii for assignments
     */
    getAvailableFunctii(): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-functii`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available functii:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available directii for assignments
     */
    getAvailableDirectii(): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-directii`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available directii:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get compartimente by directie for assignments (for cerere-type context)
     */
    getCompartimenteByDirectie(directieId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available users by directie and optional compartiment (for cerere assignments)
     */
    getAvailableUsers(directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/registratura/document-types/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available users:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Alias for getAvailableUsers - used by redaction step edit dialog
     */
    getUsersByDirectieCompartiment(directieId: number, compartimentId: number): Observable<any> {
        return this.getAvailableUsers(directieId, compartimentId);
    }

    /**
     * Get compartimente by directie for cerere assignments
     */
    getCompartimenteByDirectieForCerere(directieId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie for document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available users by directie and optional compartiment for specific cerere type
     */
    getAvailableUsersForCerereType(cerereTypeId: number, directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/registratura/document-types/${cerereTypeId}/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }

        url += `?view_all=0`; // Always view limited to access for cerere-type context

        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available users for document type:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get compartimente by directie for specific cerere type
     */
    getCompartimenteByDirectieForCerereType(cerereTypeId: number, directieId: number): Observable<any> {
        // For now we'll use the general compartimente endpoint since it's not cerere-type specific
        // but we could enhance this if needed
        const url = `${this.basePath}api/registratura/document-types/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie for document type:', error);
                return throwError(error);
            })
        );
    }

    // documente generabile, formulas
    downloadTableSignatures(id: number) {
        return this.http.get(this.downloadTableSignaturesURL + id);
    }

    generateDocument(documentId: number, templateId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentUrl + documentId + '/' + templateId,
            data
        );
    }

    generateDocumentWithFile(documentId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentWithFileUrl + documentId,
            data
        );
    }

    validateDocument(id: number, type: number, data: DocumentData) {
        // small switch here
        // || type == 2 => old, now removing
        let path =
            type == 1
                ? this.validateDocumentUrl
                : this.validateDocumentSuperiorUrl;
        return this.http.post(path + id, data);
    }

    resetDocumentValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentValidatedUrl + id, data);
    }

    resetDocumentIntocmitorValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentIntocmitorValidatedUrl + id, data);
    }

    uploadFinalDocument(id: number, data: DocumentData) {
        return this.http.post(this.uploadFinalDocumentUrl + id, data);
    }

    addToRegistru(
        cerere_id: number,
        document_id: number,
        data: { valability: Date }
    ) {
        return this.http.post(
            this.addToRegistruUrl + cerere_id + '/' + document_id,
            data
        );
    }

    /**
     * Finalizare document generat (pentru intrare/intern sau ieșire directă)
     */
    finalizeDocument(documentId: number) {
        return this.http.post(this.finalizeDocumentUrl + documentId, {});
    }

    /**
     * Trimite document la SRP (pentru documente de ieșire)
     */
    sendToSRP(documentId: number) {
        return this.http.post(this.sendToSRPUrl + documentId, {});
    }

    /**
     * Finalizare procedură SRP (doar pentru utilizatori SRP)
     */
    finalizeSRPProcedure(documentId: number) {
        return this.http.post(this.finalizeSRPUrl + documentId, {});
    }

    /**
     * Reset finalizare document - revine la in_flux
     */
    resetFinalize(documentId: number) {
        return this.http.post(this.resetFinalizeUrl + documentId, {});
    }

    /**
     * Reset trimitere SRP - revine la in_flux și șterge activitatea SRP
     */
    resetSendToSRP(documentId: number) {
        return this.http.post(this.resetSendToSRPUrl + documentId, {});
    }

    /**
     * Reset finalizare SRP - revine la pending_srp
     */
    resetFinalizeSRP(documentId: number) {
        return this.http.post(this.resetFinalizeSRPUrl + documentId, {});
    }

    downloadDocumentOfficial(id: number) {
        return this.http.get(this.downloadDocumentOfficialUrl + id);
    }

    /**
     * Download the signed official document with optional doc_type
     * @param documentId Document ID
     * @param docType Optional doc_type to specify which exemplar (1=intern, 2=cetatean)
     * @returns Observable with PDF Blob
     */
    downloadOfficialSigned(documentId: number, docType?: number): Observable<Blob> {
        let url = `${this.downloadDocumentOfficialUrl}${documentId}`;
        if (docType) {
            url += `?docType=${docType}`;
        }
        const blobOptions = {
            headers: this.httpOptions?.headers,
            responseType: 'blob' as const
        };
        return this.http.get(url, blobOptions).pipe(
            catchError((error: any) => {
                console.error('Error downloading signed official document:', error);
                return throwError(() => error);
            })
        );
    }

    istoricDocument(id: number) {
        return this.http.get(this.istoricDocumentUrl + id);
    }

    destroyDocument(id: number, data: any) {
        return this.http.post(this.destroyDocumentUrl + id, data);
    }


    updateDocument(id: number, data: DocumentData) {
        return this.http.post(this.updateDocumentUrl + id, data);
    }

    editDocGenerabilValabilty(document_id: number, data: { valability: Date }) {
        return this.http.post(
            this.updateValabilityDocGenerabilUrl + document_id,
            data
        );
    }

    downloadDocumentSigned(id: number) {
        return this.http.get(this.downloadDocumentSignedUrl + id);
    }

    downloadDocumentGenerat(id: number) {
        return this.http.get(this.downloadDocumentGeneratUrl + id);
    }

    downloadDocumentSignatureSigned(id: number) {
        return this.http.get(this.downloadDocumentSignatureSignedUrl + id);
    }

    downloadDocumentAnexa(id: number) {
        return this.http.get(this.downloadDocumentAnexaUrl + id);
    }

    /**
     * Upload anexe pentru document generat
     */
    uploadDocumentGeneratAnexe(documentGeneratId: number, data: any) {
        return this.http.post(this.uploadDocumentGeneratAnexeUrl + documentGeneratId, data);
    }

    /**
     * Delete (soft) anexa document generat
     */
    deleteDocumentGeneratAnexa(anexaId: number) {
        return this.http.delete(this.deleteDocumentGeneratAnexaUrl + anexaId);
    }

    anulareSuperiorDocument(signatureId: number, data: any) {
        return this.http.post(this.anulareSuperiorDocumentUrl + signatureId, data);
    }

    // generareDraft(id_cerere: number) {
    //     return this.http.get(this.generareDraftURL + id_cerere, {
    //         responseType: 'blob',
    //     });
    // }

    sendDocumentToIntocmitor(signatureId: number, data: any) {
        return this.http.put(this.sendDocumentToIntocmitorUrl + signatureId, data);
    }

    sendDocumentForwardIntocmitor(documentId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardIntocmitorUrl + documentId,
            data
        );
    }

    sendDocumentForwardToSigner(signatureId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardToSignerUrl + signatureId,
            data
        );
    }

    rsyncSignaturesDocumentGenerat(documentId: number, data: any = {}) {
        return this.http.post(
            this.rsyncSignaturesDocumentGeneratUrl + documentId,
            data
        );
    }

    setCetateanExemplar(documentGeneratId: number, data: any) {
        return this.http.post(
            this.setCetateanExemplarUrl + documentGeneratId,
            data
        );
    }

    sendNotificationCetateanDocumentOficial(documentGeneratId: number) {
        return this.http.get(
            this.sendNotificationCetateanDocumentOficialUrl + documentGeneratId,
            this.httpOptions
        );
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        return this.http.post(
            this.resetDocumentOficialNotificareCetateanUrl + id,
            this.httpOptions
        );
    }

    resetUploadDocumentOfficial(id_document: number) {
        return this.http.post(
            this.resetUploadDocumentOfficialUrl + id_document,
            this.httpOptions
        );
    }

    setDocTypeForDocument(id: number) { // id => id_document - generat
        return this.http.get(this.setDocTypeForDocumentUrl + id, this.httpOptions);
    }

    updateCurrentSignatureDocument(documentId: number, data: any) {
        return this.http.put(
            this.updateCurrentSignatureDocumentUrl + documentId,
            data,
            this.httpOptions
        );
    }

    storeAWB(payload: any) {
        return this.http.post(this.storeAWBUrl, payload);
    }

    findAWB(id: number) {
        return this.http.get<{ errors: boolean; data: AwbDocumentDetail; status_code: number }>(this.findAWBUrl + id);
    }

    updateAWB(id: number, payload: any) {
        return this.http.post(this.updateAWBUrl + id, payload);
    }

    duplicateAWB(id: number) {
        return this.http.post(this.duplicateAWBUrl + id, {});
    }

    // ==================== Document Seal / Extended Registration ==================== //

    /**
     * Check if document has existing registru number for a specific serie
     * @param documentId Document ID
     * @param serieId Serie ID
     * @returns Observable with existing number info if found
     */
    checkRegistruNumber(documentId: number, serieId: number): Observable<any> {
        const url = `${this.basePath}${environment.interop.indoc.documents.generabile.seal.checkRegistruNumber}${documentId}/${serieId}`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error checking registru number:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Register document with extended options (serie, valability, existing number)
     * @param documentId Document ID
     * @param data Registration data with serie_id, valability, use_existing_number
     * @returns Observable with registration result
     */
    registerExtended(documentId: number, data: any): Observable<any> {
        const url = `${this.basePath}${environment.interop.indoc.documents.generabile.seal.registerExtended}${documentId}`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error registering document extended:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Download document PDF for signature position selection
     * @param documentId Document ID
     * @param docType Optional doc_type to specify which exemplar (1=operator, 2=cetatean)
     * @returns Observable with PDF Blob
     */
    downloadForSigning(documentId: number, docType?: number): Observable<Blob> {
        let url = `${this.basePath}${environment.interop.indoc.documents.generabile.seal.downloadForSigning}${documentId}`;
        if (docType) {
            url += `?docType=${docType}`;
        }
        // Create new options with blob responseType (can't spread httpOptions as it conflicts with responseType)
        const blobOptions = {
            headers: this.httpOptions?.headers,
            responseType: 'blob' as const
        };
        return this.http.get(url, blobOptions).pipe(
            catchError((error) => {
                console.error('Error downloading document for signing:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Apply institutional seal to document at specified position
     * @param documentId Document ID
     * @param data Seal position data (page, x, y, width, height)
     * @returns Observable with seal result
     */
    applySeal(documentId: number, data: any): Observable<any> {
        const url = `${this.basePath}${environment.interop.indoc.documents.generabile.seal.applySeal}${documentId}`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error applying seal:', error);
                return throwError(error);
            })
        );
    }

    // ==================== Document Generated Signature Flow ==================== //

    /**
     * Get signature flow data for a generated document
     * @param documentGeneratId Document generated ID
     * @returns Observable with flow data including exemplar_complet and exemplar_cetatean
     */
    getDocumentGeneratedSignatureFlow(documentGeneratId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/signatures/flow/${documentGeneratId}`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document generated signature flow:', error);
                return throwError(error);
            })
        );
    }

    // ==================== Document Redaction Flow ==================== //

    /**
     * Get redaction flow data for a generated document
     * @param documentGeneratId Document generated ID
     * @returns Observable with redaction flow data
     */
    getDocumentRedactionFlow(documentGeneratId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/flow/${documentGeneratId}`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document redaction flow:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Process a redaction step (approve/complete)
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @param data Processing data (observations, file_path)
     * @returns Observable with result
     */
    processRedactionStep(documentGeneratId: number, redactionId: number, data: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/process/${redactionId}`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error processing redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Reject a redaction step
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @param data Rejection data (observations required)
     * @returns Observable with result
     */
    rejectRedactionStep(documentGeneratId: number, redactionId: number, data: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/reject/${redactionId}`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error rejecting redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Send document to next redactor
     * @param documentGeneratId Document generated ID
     * @returns Observable with result (includes is_complete flag if circuit finished)
     */
    sendToNextRedactor(documentGeneratId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/send-forward`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error sending to next redactor:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Reorder pending redaction steps (drag & drop)
     * @param documentGeneratId Document generated ID
     * @param orderIds Array of redaction IDs in new order
     * @returns Observable with result
     */
    reorderDocumentRedactions(documentGeneratId: number, orderIds: number[]): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/reorder`;
        return this.http.put<any>(url, { order: orderIds }, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error reordering document redactions:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Upload new version for Edit+Upload type redaction
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @param data Upload data (file_path, observations)
     * @returns Observable with result
     */
    uploadRedactedVersion(documentGeneratId: number, redactionId: number, data: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/upload/${redactionId}`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error uploading redacted version:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Initialize redaction circuit from template
     * @param documentGeneratId Document generated ID
     * @returns Observable with result
     */
    initializeRedactionFromTemplate(documentGeneratId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/initialize`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error initializing redaction from template:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update a redaction step (change person/role)
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @param data Update data (user_type, directie_id, compartiment_id, specific_user_id, redaction_type, description)
     * @returns Observable with result
     */
    updateRedactionStep(documentGeneratId: number, redactionId: number, data: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/update/${redactionId}`;
        return this.http.put<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Add a new redaction step to circuit
     * @param documentGeneratId Document generated ID
     * @param data Step data (user_type, directie_id, compartiment_id, redaction_type, description, after_order?)
     * @returns Observable with result
     */
    addRedactionStep(documentGeneratId: number, data: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/add`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error adding redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Remove a pending redaction step from circuit
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @returns Observable with result
     */
    removeRedactionStep(documentGeneratId: number, redactionId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/remove/${redactionId}`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error removing redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Reset a processed redaction step back to pending
     * @param documentGeneratId Document generated ID
     * @param redactionId Redaction step ID
     * @returns Observable with result
     */
    resetRedactionStep(documentGeneratId: number, redactionId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/reset/${redactionId}`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error resetting redaction step:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Send document back to creator with reason
     * @param documentGeneratId Generated document ID
     * @param data Data with reason
     */
    sendBackToCreator(documentGeneratId: number, data: { reason: string }): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/send-back-to-creator`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error sending back to creator:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Toggle redaction active status on document
     * @param documentGeneratId Generated document ID
     * @param data Data with active status and optional reason
     */
    toggleRedactionActive(documentGeneratId: number, data: { active: boolean; reason?: string }): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/toggle-active`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error toggling redaction active:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update current redactor (change which step is currently active)
     */
    updateCurrentRedactor(documentGeneratId: number, data: { redaction_id: number; new_order: number }): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/update-current`;
        return this.http.post<any>(url, data, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating current redactor:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Start redaction circuit (change from 'pending' to 'in_progress')
     */
    startRedactionCircuit(documentGeneratId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/generabile/redactions/${documentGeneratId}/start`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error starting redaction circuit:', error);
                return throwError(error);
            })
        );
    }
}
